import { MessageInstance } from 'antd/es/message/interface'
import { AddButton } from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { Expandable } from 'components/table/utility/expandableTable'
import {
  GroupingInfoModal,
  GroupingInfoModalProps,
} from 'features/groupings/GroupingInfoModal'
import React, { RefObject } from 'react'
import styled from 'styled-components'
import { GeckoSite, GeckoSiteGrouping, RolodexEntryPatchJson } from 'types'

import { GroupingsTable } from './GroupingsTable'

const TableContainer = styled.div`
  margin: 1rem 0.5rem;
`

export interface GroupingsTableCardProps {
  handleOpenGroupingInfoModal: () => void
  handleEditGroupingInfo: (row: Expandable<GeckoSiteGrouping>) => void
  isGroupingInfoModalOpen: boolean
  groupingFormRef: RefObject<HTMLFormElement>
  handleCloseGroupingInfoModal: () => void
  handleSaveGroupingInfo: () => void
  handlePatchToRolodex: (
    entry: RolodexEntryPatchJson<
      Partial<GeckoSite['data']>,
      Partial<GeckoSite['tags']>
    >,
    messageApi?: MessageInstance
  ) => void
  handleCancelGroupingInfo: () => void
  site: GroupingInfoModalProps['site']
  groupingID: string | undefined
  existingGroupings: GeckoSiteGrouping[]
  groupingInfoFormFields: GroupingInfoModalProps['groupingInfoFormFields']
  selectionMode?: boolean
  selectedGroupingId?: string | undefined
  onSelectGrouping?: (groupingId: string) => void
}

export const GroupingsTableCard: React.FC<GroupingsTableCardProps> = ({
  handleOpenGroupingInfoModal,
  handleEditGroupingInfo,
  isGroupingInfoModalOpen,
  groupingFormRef,
  handleCloseGroupingInfoModal,
  handleSaveGroupingInfo,
  handlePatchToRolodex,
  handleCancelGroupingInfo,
  site,
  groupingID,
  existingGroupings,
  groupingInfoFormFields,
  selectionMode = false,
  selectedGroupingId = undefined,
  onSelectGrouping,
}) => {
  const isEditingGrouping = !!groupingID

  return (
    <CantileverCard>
      <CantileverCard.CardHeader
        leadingContent='Groupings'
        trailingContent={
          <>
            <AddButton
              entityName='Grouping'
              onClick={handleOpenGroupingInfoModal}
            />
            <GroupingInfoModal
              site={site}
              title={isEditingGrouping ? 'Edit Grouping' : 'Add Grouping'}
              groupingInfoFormFields={groupingInfoFormFields}
              groupingID={groupingID}
              isGroupingInfoModalOpen={isGroupingInfoModalOpen}
              groupingFormRef={groupingFormRef}
              handleCloseGroupingInfoModal={handleCloseGroupingInfoModal}
              handleSaveGroupingInfo={handleSaveGroupingInfo}
              handlePatchToRolodex={handlePatchToRolodex}
              handleCancelGroupingInfo={handleCancelGroupingInfo}
            />
          </>
        }
      />
      <CantileverCard.Section>
        <TableContainer>
          <GroupingsTable
            existingGroupings={existingGroupings}
            handleEditGroupingInfo={handleEditGroupingInfo}
            selectionMode={selectionMode}
            selectedGroupingId={selectedGroupingId}
            onSelectGrouping={onSelectGrouping}
          />
        </TableContainer>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
